export const getCourse = (courses: ICourse[], courseId: number | null | undefined) => {
  console.log('getCourse', courses, courseId)
  return courses?.find((item) => item.id === Number(courseId)) ?? null
}
